/**************************************************
 * Nombre:       Detalle_Coleccion_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";

const Detalle_Coleccion_Portada = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: 'linear-gradient(0deg, rgba(0, 0, 0, 0.80) 0.04%, rgba(0, 0, 0, 0.00) 37.15%, rgba(0, 0, 0, 0.00) 62.42%, #000 99.96%), url(' + item.img + ')',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top center',
                mt: -11

            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
            >
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}
                    sx={{
                        py: 4
                    }}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 46}}>
                        <Typography sx={{
                            fontFamily: NEGRITA,
                            fontSize: 60,
                            fontWeight: 600,
                            lineHeight: 1.1
                        }}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 18, fontWeight: 400}}>{item.descripcion}</Typography>
                    </Grid>

                </Grid>

            </Grid>


        </Grid>
    )

}
export default Detalle_Coleccion_Portada